import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;

export default {
  state: {
    userForms: {},
    customerForms: {},
    policyForms: {},
    terminationForms: {},
    companyForms: {},
    potentialPolicyForms: {},
    reportForms: {},
    teamForms: {},
    teamTaxesForms: {},

    pendencyForms: {},
    customerPolicies: {},

    notesForms: {},
    callsForms: {},

    mandateForms: {},
    mandateCompaniesForms: {},
    mandateDeliveryStatuses: {},

    offerForms: {},

    leadCustomerForms: {},
  },
  getters: {
    userForms: (state) => state.userForms,
    customerForms: (state) => state.customerForms,
    policyForms: (state) => state.policyForms,
    terminationForms: (state) => state.terminationForms,
    companyForms: (state) => state.companyForms,
    potentialPolicyForms: (state) => state.potentialPolicyForms,
    reportForms: (state) => state.reportForms,
    teamForms: (state) => state.teamForms,
    teamTaxesForms: (state) => state.teamTaxesForms,

    pendencyForms: (state) => state.pendencyForms,
    customerPolicies: (state) => state.customerPolicies,

    notesForms: (state) => state.notesForms,

    callsForms: (state) => state.callsForms,

    mandateForms: (state) => state.mandateForms,
    mandateCompaniesForms: (state) => state.mandateCompaniesForms,
    mandateDeliveryStatuses: (state) => state.mandateDeliveryStatuses,

    offerForms: (state) => state.offerForms,
    leadCustomerForms: (state) => state.leadCustomerForms,
  },
  mutations: {
    setUserForms: (state, data) => {
      state.userForms = data;
    },
    setTeamForms: (state, data) => {
      state.teamForms = data;
    },
    setCustomerForms: (state, data) => {
      state.customerForms = data;
    },
    setPolicyForms: (state, data) => {
      state.policyForms = data;
    },
    setTerminationForms: (state, data) => {
      state.terminationForms = data;
    },
    setCompanyForms: (state, data) => {
      state.companyForms = data;
    },
    setPotentialPolicyForms: (state, data) => {
      state.potentialPolicyForms = data;
    },
    setReportForms: (state, data) => {
      state.reportForms = data;
    },
    setTeamTaxesForms: (state, data) => {
      state.teamTaxesForms = data;
    },

    setPendencyForms: (state, data) => {
      state.pendencyForms = data;
    },

    setNotesForms: (state, data) => {
      state.notesForms = data;
    },

    setCallsForms: (state, data) => {
      state.callsForms = data;
    },

    setMandateForms: (state, data) => {
      state.mandateForms = data;
    },

    setMandateCompaniesForms: (state, data) => {
      state.mandateCompaniesForms = data;
    },

    setMandateDeliveryStatuses: (state, data) => {
      state.mandateDeliveryStatuses = data;
    },

    setCustomerPolicies: (state, data) => {
      state.customerPolicies = data
    },

    setOfferForms: (state, data) => {
      state.offerForms = data;
    },
    setLeadCustomerForms: (state, data) => {
      state.leadCustomerForms = data;
    }
  },
  actions: {
    getUserForms: async ({ commit, dispatch }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/partials/user-forms"
        );
        const { data } = response.data;
        commit("setUserForms", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadUserForms"),
        });
      }
    },

    getUserFormsEdit: async ({ commit, dispatch }, teams) => {
      try {
        const response = await api({ requiresAuth: true }).post(
          "/v1/partials/user-forms-team", {
          teams: teams,
        }
        );
        const { data } = response.data;
        commit("setUserForms", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadUserForms"),
        });
      }
    },

    getTeamForms: async ({ commit, dispatch }, teamId = null) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/partials/team-forms",
          { params: teamId ? { team_id: teamId } : {} }
        );
        const { data } = response.data;
        commit("setTeamForms", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadTeamForms"),
        });
      }
    },
    getTeamTaxesForms: async ({ commit, dispatch }, teamId = null) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/partials/team-tax-forms",
          { params: teamId ? { team_id: teamId } : {} }
        );
        const { data } = response.data;
        commit("setTeamTaxesForms", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadTeamTaxForms"),
        });
      }
    },
    getCustomerForms: async ({ commit, dispatch }, { customer_status_id, team_id }) => {
      const normalizedTeamId = Number(team_id);
      commit("setCustomerForms", {});
      if (!Number.isInteger(normalizedTeamId) || normalizedTeamId <= 0) return;

      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/partials/customer-forms",
          {
            params: { customer_status_id, team_id: normalizedTeamId }
          }
        );

        const { data } = response.data;
        commit("setCustomerForms", data);

      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadCustomerForms"),
        });
      }
    },

    getPolicyForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const ids = Array.isArray(teamIds) ? teamIds : [teamIds];

        const query = ids.map(id => `teams[]=${encodeURIComponent(id)}`).join("&");

        const response = await api({ requiresAuth: true }).get(
          `/v1/partials/policy-forms?${query}`
        );

        const { data } = response.data;
        commit("setPolicyForms", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadPolicyForms"),
        });
      }
    },


    getCompanyForms: async ({ commit, dispatch }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/partials/company-forms"
        );
        const { data } = response.data;
        commit("setCompanyForms", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadCompanyForms"),
        });
      }
    },

    getPotentialPolicyForms: async ({ commit, dispatch }, team_id) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/partials/potential-policy-forms", {
          params: { team_id },
        }
        );
        const { data } = response.data;
        commit("setPotentialPolicyForms", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadPotentialPolicyForms"),
        });
      }
    },

    getReportForms: async ({ commit, dispatch }, team_id) => {
      try {
        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(`/v1/partials/report-forms`, {
          params: { team_id },
        });
        commit("setReportForms", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadReportForms"),
        });
      }
    },

    getPendencyForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const ids = Array.isArray(teamIds) ? teamIds : [teamIds];

        const query = ids
          .map(id => `teams[]=${encodeURIComponent(id)}`)
          .join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/pendency-forms?${query}`
        );

        commit("setPendencyForms", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadPendencyForms"),
        });
      }
    },


    getCustomerPolicies: async ({ commit, dispatch }, id) => {
      try {
        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(`/v1/partials/customer-policies/${id}`);
        commit("setCustomerPolicies", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadCustomerPolicies"),
        });
      }
    },

    getNotesForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const ids = Array.isArray(teamIds) ? teamIds : [teamIds];

        const query = ids
          .map(id => `teams[]=${encodeURIComponent(id)}`)
          .join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/note-forms?${query}`
        );

        commit("setNotesForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadNotesForms"),
        });
        return null;
      }
    },

    getCallsForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const ids = Array.isArray(teamIds) ? teamIds : [teamIds];

        const query = ids
          .map(id => `teams[]=${encodeURIComponent(id)}`)
          .join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/call-forms?${query}`
        );

        commit("setCallsForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadCallsForms"),
        });
        return null;
      }
    },

    getMandateForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const ids = Array.isArray(teamIds) ? teamIds : [teamIds];

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          "/v1/partials/mandate-forms",
          {
            params: {
              teams: ids,
            },
          }
        );
        commit("setMandateForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadMandateForms"),
        });
        return null;
      }
    },

    getMandateCompaniesForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const ids = Array.isArray(teamIds) ? teamIds : [teamIds];

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          "/v1/partials/mandate-companies-forms",
          {
            params: {
              teams: ids,
            },
          }
        );
        commit("setMandateCompaniesForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadMandateCompanyForms"),
        });
        return null;
      }
    },

    getMandateDeliveryStatuses: async ({ commit, dispatch }) => {
      try {
        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          "/v1/partials/customer-mandate-company-delivery-statuses"
        );
        commit("setMandateDeliveryStatuses", data);
      } catch (err) { 
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadMandateDeliveryStatuses"),
        });
      }
    },

    getOfferForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const ids = Array.isArray(teamIds) ? teamIds : [teamIds];

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          "/v1/partials/policy-offer-forms",
          {
            params: {
              teams: ids,
            },
          }
        );
        commit("setOfferForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadOfferForms"),
        });
        return null;
      }
    },


    getLeadCustomerForms: async ({ commit, dispatch }, teamIds) => {
      try {
        const ids = Array.isArray(teamIds) ? teamIds : [teamIds];

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          "/v1/partials/leads-forms",
          {
            params: {
              teams: ids,
            },
          }
        );
        commit("setLeadCustomerForms", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToLoadLeadCustomerForms"),
        });
        return null;
      }
    },
  },
};
